import Box from '@material-ui/core/Box';
import { CheckoutSessionStatus } from '@nemuru-eng/js-api-client';
import { Fragment } from 'react';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { CHECKOUT_SESSION_STATUS_DEFINITIONS } from '@/config/checkoutSessionConfig';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { adjustColorToPalette } from '@/utils/getColorPalette';

export function CheckoutSessionsStatusTag({ status }: { status: CheckoutSessionStatus }) {
  const { palette } = useCustomTheme();

  const richStatus = CHECKOUT_SESSION_STATUS_DEFINITIONS[status];

  const color = adjustColorToPalette(richStatus.colorPaletteName, richStatus.colorType, palette);

  return (
    <Fragment>
      {richStatus ? (
        <Box display={'flex'} alignItems={'center'}>
          <Box bgcolor={color} className={'circle mr-2'} style={{ marginBottom: '-1px' }} />
          <Box display={'flex'} flexDirection={'column'}>
            <Font variant={'body2'} color={'textPrimary'}>
              <Text tId={richStatus.SECTION_T_ID} />
            </Font>
          </Box>
        </Box>
      ) : (
        <Text tId={status} />
      )}
    </Fragment>
  );
}
